'use strict';

import React from 'react';

import { OnSchedUtils } from '../../utils';


const InitialsIcon = ({ imgUrl, name }) => {
  let icon = null
  
  if (imgUrl && imgUrl.length) {
    icon = <img src={imgUrl} />
  }
  else {
    icon = <h1 className='onsched-background-color noselecet'>{name.split(' ')[0]?.slice(0,1)}{name.split(' ')[1]?.slice(0,1)}</h1>
  }

  return (
    <div className="InitialsIcon" style={{ backgroundColor: OnSchedUtils.GetRandomColour() }}>
      {icon}
    </div>
  )
}

export default InitialsIcon
